var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 24,
    viewBox: "0 0 66 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7954 0.154968H0V4.04952H18.7954V0.154968Z",
    fill: "#EFEFF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7954 20.0208H0V23.9153H18.7954V20.0208Z",
    fill: "#EFEFF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8643 0.0181084V23.99H27.7237V0.0181084H23.8643Z",
    fill: "#EFEFF2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5732 0.0229912V23.9949H35.4326V0.0229912H31.5732Z",
    fill: "#EFEFF2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9037 10.0248H0V14.0177H17.9037V10.0248Z",
    fill: "#EFEFF2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5273 0H43.6097L48.11 24H44.0695L39.5273 0Z",
    fill: "#EFEFF2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.289 0H52.2066L47.6924 24H51.7329L56.289 0Z",
    fill: "#EFEFF2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9999 0H61.9036L57.4033 24H61.4439L65.9999 0Z",
    fill: "#EFEFF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.be65824b996fba8de452a68c756f3145.svg";
export { ForwardRef as ReactComponent };